import {
  referenceGroupTypes,
  ReferencesGroup,
  ReferencesGroupType,
} from "@/src/data/allTypes";

import { closeDrawer, openDialog, openDrawer } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import { useState } from "react";
import { openMultiReferencesPicker } from "./referencesPicker";
import { openSnomedConceptsMultiPicker } from "../../snomed/snomedConceptsMultiPicker";

export function ReferenceGroupForm({
  current,
  types,
  onChange,
}: {
  current: ReferencesGroup;
  types?: ReferencesGroupType[];
  onChange: (newValue: ReferencesGroup) => void;
}) {
  let [reference, setReference] = useState(current || ({} as ReferencesGroup));
  function setNewValue(newValue: ReferencesGroup) {
    setReference({ ...newValue });
    onChange({ ...newValue });
  }
  return (
    <div className="grid c1 gap10">
      <Input
        name={"Nom"}
        type={"text"}
        shouldFocus={true}
        value={reference.name}
        onChange={(newValue) => {
          setNewValue({ ...reference, name: newValue });
        }}
      />

      {(types?.length || 0) > 1 && (
        <Input
          name={"category"}
          type={"select"}
          value={reference.type}
          options={types?.map((type) => {
            let typeInfo = referenceGroupTypes[type];
            return { value: typeInfo?.id, label: typeInfo?.name };
          })}
          onChange={(newValue) => {
            setNewValue({ ...reference, type: newValue });
          }}
        />
      )}
    </div>
  );
}

export async function openReferenceGroupForm({
  current,
  types,
  onSave,
}: {
  current: ReferencesGroup | null | undefined;
  types?: ReferencesGroupType[];
  onSave: (newValue: ReferencesGroup) => void;
}) {
  current ||= {
    name: "",
    type: types?.[0] || "exams",
    references: [],
    usageCount: 0,
    creator: getUserId(),
    visibility: "all",
  };

  await openDialog({
    id: "referenceGroupDrawer",
    title: "Groupe de références",

    content: (
      <div className="c1 gap10">
        <ReferenceGroupForm
          current={current}
          types={types}
          onChange={(newValue) => {
            current = newValue;
          }}
        />
      </div>
    ),
    onConfirm: async (e) => {
      await openSnomedConceptsMultiPicker({
        current: current!.references?.map((r) => r?.snomedConcept) || [],
        title: "Choisir les éléments du groupe",
        category: "exam",
        parentIds: [
          "procedure",
          "labExam",
          "substance",
          "otherExam",
          "intervention",
        ],
        onConfirm: async (references) => {
          current!.references = references;
          console.log("current", current);
          current = await apiFetch("referencesGroups", "addOne", {
            group: current!,
          });
          closeDrawer("referenceGroupDrawer");
          onSave(current!);
        },
      });

      return false;
    },
  });
}
